export default __webpack_public_path__ + "static/media/logo-sider.c251bc48.png";